// import { createStore } from "redux";
import {
  persistStore,
  persistCombineReducers,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./LoginUser";
import cartConfig from "./cart";
import locationConfig from "./location";
import carConfig from "./CarRedux";
import branchConfig from "./branch";
import curLocationConfig from "./CurrentLocation";
import { configureStore } from "@reduxjs/toolkit";
import LocationPermission from "./LocationPermission";
import signInConfig from "./signInRedux";
import NumberConfig from "./NumberRedux";
import urlConfig from "./urlRedux";

const persistConfig = {
  key: "root",
  storage: storage,
};

const persistedReducer = persistCombineReducers(persistConfig, {
  user: userReducer,
  cart: cartConfig,
  loc: locationConfig,
  car: carConfig,
  branch: branchConfig,
  cLoc: curLocationConfig,
  locPer: LocationPermission,
  signinStatus: signInConfig,
  lastNumber: NumberConfig,
  lastURL: urlConfig,
});

const storedata = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// const storedata = createStore(persistedReducer);
const persistor = persistStore(storedata);

export { storedata, persistor };
